export const fileCategoryDict: { [key: number]: string } = {
  0: "マニュアル",
  1: "公開ファイル",
  2: "契約書",
};
